const urlToTitle = (url) => {
  return url.replace('/','').replace('_',' ')
}

export default urlToTitle